<template>
  <div class="h-full w-full">
    <Bar :data="chartData" :options="computedOptions" />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
)

const props = defineProps({
  chartData: {
    type: Object,
    required: true,
  },
  chartOptions: {
    type: Object,
    default: () => ({}),
  },
})

const isDarkMode = ref(document.documentElement.classList.contains('dark'))

const computedOptions = computed(() => {
  const darkMode = isDarkMode.value
  
  return {
    ...props.chartOptions,
    plugins: {
      ...props.chartOptions.plugins,
      legend: {
        ...props.chartOptions.plugins?.legend,
        labels: {
          ...props.chartOptions.plugins?.legend?.labels,
          color: darkMode ? '#E5E7EB' : '#374151',
        },
      },
      tooltip: {
        ...props.chartOptions.plugins?.tooltip,
        backgroundColor: darkMode ? '#1F2937' : '#FFFFFF',
        titleColor: darkMode ? '#F9FAFB' : '#111827',
        bodyColor: darkMode ? '#E5E7EB' : '#374151',
        borderColor: darkMode ? '#374151' : '#E5E7EB',
        borderWidth: 1,
      },
    },
    scales: {
      ...props.chartOptions.scales,
      x: {
        ...props.chartOptions.scales?.x,
        ticks: {
          ...props.chartOptions.scales?.x?.ticks,
          color: darkMode ? '#9CA3AF' : '#6B7280',
        },
        grid: {
          ...props.chartOptions.scales?.x?.grid,
          color: darkMode ? '#374151' : '#E5E7EB',
        },
      },
      y: {
        ...props.chartOptions.scales?.y,
        ticks: {
          ...props.chartOptions.scales?.y?.ticks,
          color: darkMode ? '#9CA3AF' : '#6B7280',
        },
        grid: {
          ...props.chartOptions.scales?.y?.grid,
          color: darkMode ? '#374151' : '#E5E7EB',
        },
      },
    },
  }
})

// Watch for dark mode changes
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.attributeName === 'class') {
      isDarkMode.value = document.documentElement.classList.contains('dark')
    }
  })
})

observer.observe(document.documentElement, {
  attributes: true,
  attributeFilter: ['class'],
})
</script>
